<template>
    <div class="container">
        <template v-if="state && state.items.length">
            <ais-stats>
                <p slot-scope="{ nbHits }">{{ nbHits }} results</p>
            </ais-stats>

            <ais-hits>
                <div slot-scope="{ items }">
                    <p v-if="!items.length" class="search-alert">
                        No results found. Enter a new search above or try map view and zoom in to
                        choose an area to search
                    </p>

                    <template v-if="$root.index == 'installers'">
                        <ListViewInstaller v-for="item in items" :key="item.id" :item="item" />
                    </template>
                    <template v-else>
                        <ListViewRetailer v-for="item in items" :key="item.id" :item="item" />
                    </template>
                </div>
            </ais-hits>
        </template>

        <p v-else class="mt-md search-alert">
            Start typing above to begin your search
        </p>

        <ais-pagination
            v-if="$root.isMobile"
            v-slot="{
                currentRefinement,
                nbPages,
                isFirstPage,
                isLastPage,
                refine,
                createURL
            }"
        >
            <ul class="ais-Pagination-list">
                <li
                    v-if="isFirstPage"
                    class="ais-Pagination-item ais-Pagination-item--previousPage ais-Pagination-item--disabled"
                >
                    <span aria-label="Previous" class="ais-Pagination-link">‹</span>
                </li>

                <li v-else class="ais-Pagination-item ais-Pagination-item--previousPage">
                    <a
                        aria-label="Previous"
                        :href="createURL(currentRefinement - 1)"
                        class="ais-Pagination-link"
                        @click.prevent="refine(currentRefinement - 1)"
                    >
                        ‹
                    </a>
                </li>

                <li class="ais-Pagination-info">{{ currentRefinement + 1 }} of {{ nbPages }}</li>

                <li
                    v-if="isLastPage"
                    class="ais-Pagination-item ais-Pagination-item--nextPage ais-Pagination-item--disabled"
                >
                    <span aria-label="Next" class="ais-Pagination-link">›</span>
                </li>

                <li v-else class="ais-Pagination-item ais-Pagination-item--nextPage">
                    <a
                        aria-label="Next"
                        :href="createURL(currentRefinement + 1)"
                        class="ais-Pagination-link"
                        @click.prevent="refine(currentRefinement + 1)"
                    >
                        ›
                    </a>
                </li>
            </ul>
        </ais-pagination>

        <ais-pagination v-else :show-first="false" :show-last="false" :padding="2" />
    </div>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors';

import ListViewInstaller from './ListViewInstaller.vue';
import ListViewRetailer from './ListViewRetailer.vue';

export default {
    components: {
        ListViewInstaller,
        ListViewRetailer
    },

    mixins: [createWidgetMixin({ connector: connectCurrentRefinements })],

    computed: {
        widgetParams() {
            return {
                includedAttributes: ['query', 'accreditations', 'systemTypes']
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.search-alert {
    padding: 1em;
    text-align: center;
    background-color: #414042;
    color: #ffffff;
    font-size: 16px;
}

.ais-Stats {
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 14px;
    font-weight: 500;
}

::v-deep {
    .ais-Pagination-list {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 3em;
        margin-bottom: 4em;
    }

    .ais-Pagination-link {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        border-radius: 100%;
        color: #414042;
        background-color: #ffffff;
        border: 1px solid #ffffff;
        outline: none;
        cursor: pointer;
        z-index: 0;
        font-weight: 500;
    }

    .ais-Pagination-item--previousPage,
    .ais-Pagination-item--nextPage {
        .ais-Pagination-link {
            color: #ffffff;
            background-color: #ef6e0b;
            border: 1px solid #ef6e0b;
        }
    }

    .ais-Pagination-item--previousPage {
        margin-right: auto;
    }

    .ais-Pagination-item--nextPage {
        margin-left: auto;
    }

    .ais-Pagination-item--selected {
        .ais-Pagination-link {
            border: 1px solid #ef6e0b;
            color: #ef6e0b;
        }
    }

    .ais-Pagination-item--disabled {
        .ais-Pagination-link {
            color: #afafaf;
            border: 1px solid #afafaf;
            background-color: #ffffff;
        }
    }

    .ais-Pagination-info {
        font-size: 14px;
        font-weight: 600;
        color: #afafaf;
    }
}
</style>
